import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import axios from 'axios';
import Swal from 'sweetalert2';
import BaseApi from '../api/BaseApi';

import Footer from '../element/Footer';
import NavBar from '../element/NavBar';
import { useRootStore } from 'core/hooks/use-root-store';
import { CheckEmailCodeForm } from '../forms/applyJobForms/ApplyJobCheckEmailForm';

export const SmsConfirmed = () => {
   const { t } = useTranslation('global');
   const rootStore = useRootStore();
   const navigate = useNavigate();
   const [isSubmitting, setIsSubmitting] = useState(false);
   const [emailConfirmCode, setEmailConfirmCode] = useState('');
   const [emailConfirmCodeError, setEmailConfirmCodeError] = useState('');
   const currentLanguage = Cookies.get('selectedLanguage') || 'ukr';

   const contactPhone = window.localStorage.getItem('comfirmedPhone')

   const handleEmailConfirm = async (e) => {
      e.preventDefault();
      try {
         if (emailConfirmCode.trim() === '') {
            setEmailConfirmCodeError(t('jobDescription.codeRequired'));
         }

         if (!emailConfirmCodeError) {
            setIsSubmitting(true);

            const response = await axios.post(BaseApi + '/jobApply/code', {
               code: parseInt(emailConfirmCode),
               email_address: '',
               contact: contactPhone,
            });

            if (response.data.status === 200 && response.data.response.user.token !== '') {
               rootStore.userStore.setUser(response.data.response.user);
               const { token, contact, user_id, last_name, user_type, first_name, email_address } =
                  response.data.response.user;

               const Toast = Swal.mixin({
                  toast: true,
                  timer: 5000,
                  position: 'top-end',
                  timerProgressBar: true,
                  showConfirmButton: false,
                  didOpen: (toast) => {
                     toast.addEventListener('mouseenter', Swal.stopTimer);
                     toast.addEventListener('mouseleave', Swal.resumeTimer);
                  },
               });

               if (user_type !== 'candidate') {
                  Toast.fire({
                     icon: 'error',
                     title: t('jobseekerLogin.wrongCredentials'),
                  });
                  setEmailConfirmCode('');
                  setEmailConfirmCodeError('');
               } else {

                  await axios.post(BaseApi + '/setcontext', {
                     user_id,
                     user_type,
                     lang: currentLanguage === 'ukr' ? 'uk' : currentLanguage,
                  });

                  Cookies.set('lname', last_name);
                  Cookies.set('user_id', user_id);
                  Cookies.set('fname', first_name);
                  Cookies.set('tokenClient', token);
                  Cookies.set('user_type', user_type);
                  Cookies.set('contactNumber', contact);
                  Cookies.set('emailAddress', email_address);

                  Toast.fire({
                     icon: 'success',
                     title: t('jobseekerLogin.welcome') + ', ' + first_name,
                  });
                  navigate('/candidate/my-cv-list');
               }
            } else {
               setEmailConfirmCodeError(response.data.message);
            }

            setIsSubmitting(false);
         }
      } catch (error) {
         setIsSubmitting(false);

         const Toast = Swal.mixin({
            toast: true,
            timer: 5000,
            position: 'top-end',
            timerProgressBar: true,
            showConfirmButton: false,
            didOpen: (toast) => {
               toast.addEventListener('mouseenter', Swal.stopTimer);
               toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
         });

         Toast.fire({
            icon: 'error',
            title: t('jobDescription.checkCodeError'),
         });
      }
   };

   return (
      <div className="aboutUs">
         <NavBar />
         <div className="aboutusSection1 text-center">
            <h1>{t('emailConfirmed.pageTitle')}</h1>
            <h6 className="text-muted fw-normal">
               <Link to="/" style={{ color: 'grey' }}>
                  {t('navHeaders.home')}
               </Link>
               {' / '}
               {t('emailConfirmed.pageTitle')}
            </h6>
         </div>
         <div className="container aboutusSection4 text-center">
            <div className="cards row justify-content-center">
               <div className="card col">
                  <div className="card-body p-4">
                     <h2 className="aboutusSec4Header mx-auto" style={{ margin: '3% 0 3% 0' }}>
                        {t('emailConfirmed.emailConfirmedHeader1.1')}
                        <span className="textGradient">
                           {' '}
                           <span className="SubHaddingTxt">
                              {t('emailConfirmed.emailConfirmedHeader1.2')}
                           </span>
                        </span>
                     </h2>
                     <p className="mb-4">{t('emailConfirmed.description1')}</p>
                     <p className="mb-4">
                        {t('emailConfirmed.description3.1')}
                        <span className="ms-1 fw-bold">{"вкажіть код який прийшов на ваш телефон"}</span>
                     </p>
                     <div
                        style={{
                           maxWidth: '400px',
                           margin: '24px auto'
                        }}
                     >
                        <CheckEmailCodeForm
                           phoneConfirmed
                           isSubmitting={isSubmitting}
                           onSubmit={handleEmailConfirm}
                           emailConfirmCode={emailConfirmCode}
                           setEmailConfirmCode={setEmailConfirmCode}
                           emailConfirmCodeError={emailConfirmCodeError}
                           setEmailConfirmCodeError={setEmailConfirmCodeError}
                        />
                     </div>
                     <p className="mb-4">
                        {t('emailConfirmed.description2')}{' '}
                        <a href="mailto:feedback@grc.ua">feedback@grc.ua</a>
                     </p>
                  </div>
               </div>
            </div>
         </div>
         <Footer />
      </div>
   );
};
